var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1000 999.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{fill:#ff6254;}.cls-4{fill:#efefef;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 1000,
    height: 999.95
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "W Stacked Reversed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "W_Stacked_Reversed",
    "data-name": "W Stacked Reversed"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1000,499.92c0,276.17-223.92,500-500,500S0,776.09,0,499.92,223.86,0,500,0s500,223.84,500,499.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "201.48 315.13 297.42 315.13 385.52 526.56 499.54 250.52 616.51 530.48 698.76 315.13 800.52 315.13 616.51 759.52 499.54 483.5 385.52 753.65 201.48 315.13"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWNetwork);
export default __webpack_public_path__ + "static/media/WNetwork.455e2e707535f6be6a7ef5e9634d78a4.svg";
export { ForwardRef as ReactComponent };